<template>
  <Select
    :disabled="disabled"
    v-model="now"
    style="width: 100%"
    :multiple="multiple"
    :readonly="false"
    :filterable="true"
    :allow-create="false"
    @on-create="handleCreate1($event)"
    @on-change="change"
    :clearable="true"
    @on-clear="clear"
  >
    <Option
      :value="selectType == 'obj' ? y.id : y"
      v-for="(y, index1) in selectItems"
      :key="index1"
      :label="selectType == 'obj' ? y.name : y"
    >
      <span>{{ selectType == "obj" ? y.name : y }}</span>
    </Option>
    <Option v-if="addItem">
      <Button @click="add" size="small" type="error">添加项目</Button>
    </Option>
  </Select>
</template>
<script>
export default {
  props: [
    "selectItems",
    "selectType",
    "multiple",
    "data",
    "disabled",
    "addItem",
  ],
  data() {
    return {
      now: 0,
    };
  },
  model: {
    prop: "data",
    event: "send",
  },
  methods: {
    ff() {
      this.now = this.data;
    },
    handleCreate1(v) {
      //this.selectItems.push(v);
    },
    clear() {
      this.$emit("id", null);
      this.$emit("name", "");
    },
    change(v) {
      this.$emit("send", v);
      this.$emit("id", v);
      if (this.selectType == "obj") {
        for (let i = 0; i < this.selectItems.length; i++) {
          if (v == this.selectItems[i].id) {
            //alert(this.selectItems[i].name);
            this.$emit("name", this.selectItems[i].name);
            break;
          }
        }
      }
    },
    add() {
      this.$emit("add");
    },
  },
  mounted() {
    this.ff();
  },
  watch: {
    data() {
      this.ff();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/common/lySelect.vue